


















































































import { Component, Vue } from "vue-property-decorator";
import { mapPreferences } from "vue-preferences";
import axios from "@/plugins/axios";
import { mapGetters } from "vuex";
import MediaCard from "@/components/Media/MediaCard.vue";
import { Media } from "@/types";
import { serialize } from "object-to-formdata";

@Component({
  components: { MediaCard },
  computed: {
    ...mapPreferences({ ampm: { defaultValue: true } }),
    ...mapGetters(["isLoggedIn", "isAdmin"])
  }
})
export default class MediaList extends Vue {
  editing = false;
  media: Media = {
    episodes: 0,
    references: [],
    trailer: "",
    title: "",
    type: "",
    description: "",
    image: "",
    genres: [],
    duration: 0
  };
  image = null;
  loading = false;

  get imagePreview() {
    if (this.image) return URL.createObjectURL(this.image);
    return this.media.image;
  }

  mounted() {
    if (Number(this.$route.params.id) > 0)
      this.getMedia(Number(this.$route.params.id));
  }

  getMedia(id: number) {
    axios.get("/api/media/" + id).then(async response => {
      const r = response.data;
      console.log(r);
      this.media = r;
      this.loading = false;
    });
  }

  get form() {
    return (this.$refs.form as unknown) as {
      reset(): void;
      resetValidation(): void;
      validate(): boolean;
    };
  }

  save() {
    if (this.form.validate()) {
      const data = { json: JSON.stringify(this.media), image: this.image };
      this.loading = true;
      this.editing = false;
      if (this.media.id) {
        axios.post("/api/media", serialize(data)).then(() => {
          this.loading = false;
        });
      } else {
        axios.put("/api/media", serialize(data)).then(() => {
          this.loading = false;
        });
      }
    }
  }
}
